import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TeamManageDataSource } from './team-manage-datasource';
import { TeamService } from 'src/app/services/team.service';
import { Team } from 'src/app/models/team';
import { TeamManageDialogComponent } from '../team-manage-dialog/team-manage-dialog.component';
import { UserService } from 'src/app/services/user.service';
import { Define } from '@app/models/define';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-team-manage',
  templateUrl: './team-manage.component.html',
  styleUrls: ['./team-manage.component.css']
})
export class TeamManageComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: TeamManageDataSource;

  constructor(
    private teamService: TeamService,
    private userService: UserService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns: string[];

  async ngOnInit() {
    const data = await this.teamService.getTeams();
    console.log('team get');
    console.log(data);
    this.dataSource = new TeamManageDataSource(this.paginator, this.sort, data);
    const auth = await this.userService.getCurrentManageAuth();
    if (auth === undefined || auth < Define.ManageAuthority.Administrator) {
      this.displayedColumns = ['name', 'edit'];
    } else {
      this.displayedColumns = ['name', 'edit', 'delete'];
    }

  }



  openDialog(rowData: Team) {

    console.log(`openDialog open`);

    const data = Object.assign({}, rowData);
    const dialogRef = this.dialog.open(TeamManageDialogComponent, { data });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`dialog close. result:${result}`);
      if (this.dataSource !== undefined && result === true) {
        this.ngOnInit();
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action);
  }


  delete(rowData: Team) {
    console.log(`delete team`);
    console.log(rowData);

    const data = '削除します。よろしいですか？';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { data });
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.teamService.checkExistTeamMember(rowData).then(async (isExistTeamMember) => {
          if (isExistTeamMember) {
            this.openSnackBar('在籍ユーザーがいる組織は削除できません。', '閉じる');
          } else {
            await this.teamService.deleteTeam(rowData);
            this.ngOnInit();
            console.log(`delete team execute`);
          }
        });
      }
    });
  }
}
